import React, { useCallback, useMemo } from "react";
import { Button as ReactButton } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { clearUIBlocker } from "../../actions/session";
import { useMainContext } from "../../contexts";
import Icon from "../../controls/Icon";
/**
 * Modal overlay that blocks user interaction during certain operations.
 * Displays an icon, description text, and optionally a cancel button.
 * Used during profile switching, game discovery, or other long-running tasks.
 * For both layouts.
 */
export const UIBlocker = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { api } = useMainContext();
    const uiBlockers = useSelector((state) => state.session.base.uiBlockers);
    const uiBlockerId = useMemo(() => {
        return uiBlockers ? Object.keys(uiBlockers)[0] : undefined;
    }, [uiBlockers]);
    const blocker = uiBlockerId !== undefined ? uiBlockers[uiBlockerId] : undefined;
    const onUnblock = useCallback((id) => {
        api?.events.emit(`force-unblock-${id}`);
        dispatch(clearUIBlocker(id));
    }, [api, dispatch]);
    if (uiBlockerId === undefined || blocker === undefined) {
        return null;
    }
    return (React.createElement("div", { className: "ui-blocker" },
        React.createElement(Icon, { name: blocker.icon }),
        React.createElement("div", { className: "blocker-text" }, blocker.description),
        blocker.mayCancel ? (React.createElement(ReactButton, { onClick: () => onUnblock(uiBlockerId) }, t("Cancel"))) : null));
};
